import MathLight from './MathLight.js'

var cameraLight = {
    clampVFOV: function(currentFov, maxHFov, width, height) {//限制currentFov, 使之造成的横向fov不大于指定值maxHFov
        var r = cameraLight.getHFOVFromVFOV(currentFov, width, height);
        return r > maxHFov ? cameraLight.getVFOVFromHFOV(maxHFov, width, height) : currentFov
    },
    getHFOVForCamera: function(camera,  getRad) {
        return cameraLight.getHFOVByScreenPrecent(camera.fov, camera.aspect, getRad)
    }, 
    //add
    getHFOVByScreenPrecent: function(fov, percent, getRad) { //当fov为占比百分百时，percent代表在屏幕上从中心到边缘的占比
        let rad = 2 * Math.atan(percent * Math.tan(fov * MathLight.RADIANS_PER_DEGREE / 2));
        if(getRad)return rad 
        else return rad * MathLight.DEGREES_PER_RADIAN;
    }
};

export default cameraLight